export const SALES_PHONE_NUMBER_DATA_ID = 'phone-number'
export const SALES_PHONE_NUMBER_FORMATTED = '(800) 543-7927'
export const SALES_PHONE_NUMBER_TEL = 'tel:+18005437927'

export const SUPPORT_PHONE_NUMBER_FORMATTED = '(877) 448-4438'
export const SUPPORT_PHONE_NUMBER_TEL = 'tel:+18774484438'
